import '../../assets/css/newPageStyle.css';
import bannerImg from '../../assets/img/imgNewPage/banner_4.png';
import logo1 from '../../assets/img/imgNewPage/logo1.png';
import logo2 from '../../assets/img/imgNewPage/logo2.png';
import logo3 from '../../assets/img/imgNewPage/platform-logo2.png';
import logo4 from '../../assets/img/imgNewPage/logo4.png';
import logo5 from '../../assets/img/imgNewPage/platform-logo.png';
import videoImg from '../../assets/img/imgNewPage/video-img.png';
import streamefyImage from '../../assets/img/imgNewPage/streamefy.png';
import image9 from '../../assets/img/imgNewPage/image9.png';
import image8 from '../../assets/img/imgNewPage/image8.png';
import image7 from '../../assets/img/imgNewPage/image7.png';
import image6 from '../../assets/img/imgNewPage/image6.png';
import image5 from '../../assets/img/imgNewPage/image5.png';
import image4 from '../../assets/img/imgNewPage/image4.png';
import image3 from '../../assets/img/imgNewPage/image3.png';
import image2 from '../../assets/img/imgNewPage/image2.png';
import image1 from '../../assets/img/imgNewPage/image1.png';
import image from '../../assets/img/imgNewPage/image.png';
import smart_tv from '../../assets/img/TVf2.png';
import mobile_frame from '../../assets/img/m-background.png';

import { useEffect, useState } from 'react';
import ContactUsPage from '../ContactUs/contactUs';

/**
 * Personalized Component
 *
 * This component manages the state for showing and hiding a video modal.
 * It uses React state to control the visibility of the modal
 * and passes handler functions to the VideoModal component.
 */
const Personalized = () => {
	const videoSrc = require('../../assets/videos/CORPORATE_WEBSITE_TV_Video-1.mp4') as string;
	// State to track whether the video modal is open
	const [isVideoOpen, setIsVideoOpen] = useState(false);
	const [isModalOpen, setIsModalOpen] = useState(false);

	/**
	 * Opens the video modal by setting isVideoOpen to true.
	 */
	const openVideo = () => {
		setIsVideoOpen(true);
	};

	/**
	 * Closes the video modal by setting isVideoOpen to false.
	 */
	const closeVideo = () => {
		setIsVideoOpen(false);
	};

	const handleOpenModal = () => {
		setIsModalOpen(true);
	};

	const handleCloseModal = () => {
		setIsModalOpen(false);
	};

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	return (
		<div className="background-color-ani">
			<>
				<section className="top-section">
					<div className="custom-container">
						<div className="inner-top">
							<h1>Launch Your Own OTT App Fully Branded</h1>
							<p>
								Turn your content into a full-fledged TV experience — without building from scratch. No tech headaches. No coding. Just your platform,
								made easy.
							</p>
							<a
								href="#"
								className="demo"
								onClick={(e) => {
									e.preventDefault();
									handleOpenModal();
								}}
							>
								Contact Sales
								<svg xmlns="http://www.w3.org/2000/svg" width="35px" height="35px" viewBox="0 0 24 24" fill="none">
									<path d="M6 12H18M18 12L13 7M18 12L13 17" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
								</svg>
							</a>
							<div className="top-img">
								<img src={bannerImg} alt="" />
								{/* <video autoPlay muted loop playsInline>
							<source src="https://vidflow.co/assets/img/header_media/wedding_desktop1.mp4" type="video/mp4" />
							Your browser does not support the video tag.
							</video>
								<img src={mobile_frame} alt="" /> */}
							</div>
						</div>
					</div>
				</section>
				<section className="why-choose">
					<div className="custom-container">
						<div className="inner-why">
							<h2 className="main-heading">
								Why <span>Choose</span> Our TV App?
							</h2>
							<div className="why-boxs">
								<div className="box">
									<div className="gradiant-inner">
										<div className="box-icon">
											<svg
												xmlns="http://www.w3.org/2000/svg"
												xmlnsXlink="http://www.w3.org/1999/xlink"
												width="90"
												height="90"
												viewBox="0 0 90 90"
												fill="none"
											>
												<path
													d="M20 1H70C80.4934 1 89 9.50659 89 20V70C89 80.4934 80.4934 89 70 89H20C9.50659 89 1 80.4934 1 70V20C1 9.50659 9.50659 1 20 1Z"
													fill="#050108"
													stroke="url(#paint0_linear_330_520)"
													strokeWidth="2"
												/>
												<rect x="13" y="13" width="65" height="65" rx="20" fill="url(#pattern0_330_520)" />
												<defs>
													<pattern id="pattern0_330_520" patternContentUnits="objectBoundingBox" width="1" height="1">
														<use xlinkHref="#image0_330_520" transform="scale(0.00195312)" />
													</pattern>
													<linearGradient id="paint0_linear_330_520" x1="45" y1="0" x2="45" y2="90" gradientUnits="userSpaceOnUse">
														<stop stopColor="#941AF2" />
														<stop offset="1" stopColor="#EFBD8A" />
													</linearGradient>
													<image id="image0_330_520" width="512" height="512" preserveAspectRatio="none" xlinkHref={image9} />
												</defs>
											</svg>
										</div>
										<h3>Your Brand, Your Look</h3>
										<p>Your logo, name, and design - everything viewers see is you</p>
									</div>
								</div>

								<div className="box">
									<div className="gradiant-inner">
										<div className="box-icon">
											<svg
												xmlns="http://www.w3.org/2000/svg"
												xmlnsXlink="http://www.w3.org/1999/xlink"
												width="90"
												height="90"
												viewBox="0 0 90 90"
												fill="none"
											>
												<path
													d="M20 1H70C80.4934 1 89 9.50659 89 20V70C89 80.4934 80.4934 89 70 89H20C9.50659 89 1 80.4934 1 70V20C1 9.50659 9.50659 1 20 1Z"
													fill="#050108"
													stroke="url(#paint0_linear_330_521)"
													strokeWidth="2"
												/>
												<rect x="18" y="18" width="55" height="55" fill="url(#pattern0_330_521)" />
												<defs>
													<pattern id="pattern0_330_521" patternContentUnits="objectBoundingBox" width="1" height="1">
														<use xlinkHref="#image0_330_521" transform="scale(0.00195312)" />
													</pattern>
													<linearGradient id="paint0_linear_330_521" x1="45" y1="0" x2="45" y2="90" gradientUnits="userSpaceOnUse">
														<stop stopColor="#941AF2" />
														<stop offset="1" stopColor="#EFBD8A" />
													</linearGradient>
													<image id="image0_330_521" width="512" height="512" preserveAspectRatio="none" xlinkHref={image8} />
												</defs>
											</svg>
										</div>
										<h3>No Coding Required</h3>
										<p>No tech headaches. Just your platform, made easy</p>
									</div>
								</div>

								<div className="box">
									<div className="gradiant-inner">
										<div className="box-icon">
											<svg
												xmlns="http://www.w3.org/2000/svg"
												xmlnsXlink="http://www.w3.org/1999/xlink"
												width="90"
												height="90"
												viewBox="0 0 90 90"
												fill="none"
											>
												<path
													d="M20 1H70C80.4934 1 89 9.50659 89 20V70C89 80.4934 80.4934 89 70 89H20C9.50659 89 1 80.4934 1 70V20C1 9.50659 9.50659 1 20 1Z"
													fill="#050108"
													stroke="url(#paint0_linear_330_522)"
													strokeWidth="2"
												/>
												<rect x="18" y="18" width="55" height="55" fill="url(#pattern0_330_522)" />
												<defs>
													<pattern id="pattern0_330_522" patternContentUnits="objectBoundingBox" width="1" height="1">
														<use xlinkHref="#image0_330_522" transform="scale(0.00195312)" />
													</pattern>
													<linearGradient id="paint0_linear_330_522" x1="45" y1="0" x2="45" y2="90" gradientUnits="userSpaceOnUse">
														<stop stopColor="#941AF2" />
														<stop offset="1" stopColor="#EFBD8A" />
													</linearGradient>
													<image id="image0_330_522" width="512" height="512" preserveAspectRatio="none" xlinkHref={image7} />
												</defs>
											</svg>
										</div>
										<h3>Multi-Platform Ready</h3>
										<p>Amazon Firestick, Android, Samsung and LG TV support included</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
				<div className="perfect-sec">
					<div className="custom-container">
						<div className="inner-perfect">
							<h2 className="main-heading">
								Perfect <span>For</span> :
							</h2>
							<div className="perfect-boxs">
								<div className="p-box">
									<div className="gradiant-inner">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											xmlnsXlink="http://www.w3.org/1999/xlink"
											width="72"
											height="72"
											viewBox="0 0 72 72"
											fill="none"
										>
											<rect width="72" height="72" fill="url(#pattern0_66_1729)" />
											<defs>
												<pattern id="pattern0_66_1729" patternContentUnits="objectBoundingBox" width="1" height="1">
													<use xlinkHref="#image0_66_1729" transform="scale(0.00195312)" />
												</pattern>
												<image id="image0_66_1729" width="512" height="512" preserveAspectRatio="none" xlinkHref={image6} />
											</defs>
										</svg>
										<h3>Wedding Films</h3>
										<p>Beautiful memories on big screen</p>
									</div>
								</div>

								<div className="p-box">
									<div className="gradiant-inner">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											xmlnsXlink="http://www.w3.org/1999/xlink"
											width="70"
											height="70"
											viewBox="0 0 70 70"
											fill="none"
										>
											<path d="M0 0H70V70H0V0Z" fill="url(#pattern0_66_1744)" />
											<defs>
												<pattern id="pattern0_66_1744" patternContentUnits="objectBoundingBox" width="1" height="1">
													<use xlinkHref="#image0_66_1744" transform="scale(0.00195312)" />
												</pattern>
												<image id="image0_66_1744" width="512" height="512" preserveAspectRatio="none" xlinkHref={image5} />
											</defs>
										</svg>
										<h3>Exclusive Releases</h3>
										<p>Premium content delivery</p>
									</div>
								</div>

								<div className="p-box">
									<div className="gradiant-inner">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											xmlnsXlink="http://www.w3.org/1999/xlink"
											width="72"
											height="72"
											viewBox="0 0 72 72"
											fill="none"
										>
											<path d="M0 0H72V72H0V0Z" fill="url(#pattern0_66_1739)" />
											<defs>
												<pattern id="pattern0_66_1739" patternContentUnits="objectBoundingBox" width="1" height="1">
													<use xlinkHref="#image0_66_1739" transform="scale(0.00195312)" />
												</pattern>
												<image id="image0_66_1739" width="512" height="512" preserveAspectRatio="none" xlinkHref={image4} />
											</defs>
										</svg>
										<h3>Streaming</h3>
										<p>Netflix-like experience</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<section className="we-support">
					<div className="custom-container">
						<div className="border-gradiant">
							<div className="inner-support">
								<h2 className="main-heading">
									Platform We <span>Support</span>
								</h2>
								<ul>
									<li>
										<img src={logo1} alt="" />
									</li>
									<li>
										<img src={logo2} alt="" />
									</li>
									<li className="black-overlay">
										<img src={logo3} alt="" />
										{/* <span className="coming-soon">coming soon...</span> */}
									</li>
									<li>
										<img src={logo4} alt="" />
									</li>
									<li className="black-overlay">
										<img src={logo5} alt="" />
										{/* <span className="coming-soon">coming soon...</span> */}
									</li>
								</ul>
							</div>
						</div>
					</div>
				</section>
				<section className="easy-steps">
					<div className="custom-container">
						<h2 className="main-heading">
							Get Started in <span>3 Easy Steps</span>
						</h2>

						<div className="inner-steps">
							<div className="step-box">
								<svg
									xmlns="http://www.w3.org/2000/svg"
									xmlnsXlink="http://www.w3.org/1999/xlink"
									width="75"
									height="75"
									viewBox="0 0 75 75"
									fill="none"
								>
									<rect width="75" height="75" fill="url(#pattern0_73_236)" />
									<defs>
										<pattern id="pattern0_73_236" patternContentUnits="objectBoundingBox" width="1" height="1">
											<use xlinkHref="#image0_73_236" transform="scale(0.00195312)" />
										</pattern>
										<image id="image0_73_236" width="512" height="512" preserveAspectRatio="none" xlinkHref={image3} />
									</defs>
								</svg>
								<h3>Upload Your Videos</h3>
								<p className="discription">Drag and drop your video files here or click to browse your device.</p>
								<div className="number">
									<p>1</p>
								</div>
							</div>

							<div className="step-box">
								<svg
									xmlns="http://www.w3.org/2000/svg"
									xmlnsXlink="http://www.w3.org/1999/xlink"
									width="63"
									height="63"
									viewBox="0 0 63 63"
									fill="none"
								>
									<rect width="63" height="63" fill="url(#pattern0_73_239)" />
									<defs>
										<pattern id="pattern0_73_239" patternContentUnits="objectBoundingBox" width="1" height="1">
											<use xlinkHref="#image0_73_239" transform="scale(0.00195312)" />
										</pattern>
										<image id="image0_73_239" width="512" height="512" preserveAspectRatio="none" xlinkHref={image2} />
									</defs>
								</svg>
								<h3>Customize Branding</h3>
								<p className="discription">Your logo, your name, your look — everything your audience sees is you.</p>
								<div className="number">
									<p>2</p>
								</div>
							</div>

							<div className="step-box">
								<svg
									xmlns="http://www.w3.org/2000/svg"
									xmlnsXlink="http://www.w3.org/1999/xlink"
									width="60"
									height="60"
									viewBox="0 0 60 60"
									fill="none"
								>
									<rect width="60" height="60" fill="url(#pattern0_73_244)" />
									<defs>
										<pattern id="pattern0_73_244" patternContentUnits="objectBoundingBox" width="1" height="1">
											<use xlinkHref="#image0_73_244" transform="scale(0.00195312)" />
										</pattern>
										<image id="image0_73_244" width="512" height="512" preserveAspectRatio="none" xlinkHref={image1} />
									</defs>
								</svg>
								<h3>Publish to OTT Platform</h3>
								<p className="discription">Stream Your Content – Weddings, Events, and More, Under Your Brand!</p>
								<div className="number">
									<p>3</p>
								</div>
							</div>
						</div>
					</div>
				</section>
				<section className="poster">
					<div className="custom-container">
						<div className="inner-poster">
							<div className="poster-img">
								<div className="video-svg">
									<div className="video-play-button open-btn" onClick={openVideo}>
										<span className="play-icon"></span>
									</div>
								</div>

								<img src={smart_tv} alt="" />
							</div>
							<div className="poster-text">
								<div className="rdy-text">
									<h3>
										Ready to <span>Launch</span> <span>Your</span> TV App?
									</h3>
								</div>
								<p>Join content creators already streaming on TV. Watch your content come to life on TV</p>
								<div className="poster-btn">
									<div className="border-gradiant">
										<button className="open-btn" onClick={openVideo}>
											Watch video
											<svg
												xmlns="http://www.w3.org/2000/svg"
												xmlnsXlink="http://www.w3.org/1999/xlink"
												width="30"
												height="30"
												viewBox="0 0 30 30"
												fill="none"
											>
												<rect width="30" height="30" fill="url(#pattern0_73_230)" />
												<defs>
													<pattern id="pattern0_73_230" patternContentUnits="objectBoundingBox" width="1" height="1">
														<use xlinkHref="#image0_73_230" transform="scale(0.00195312)" />
													</pattern>
													<image id="image0_73_230" width="512" height="512" preserveAspectRatio="none" xlinkHref={image} />
												</defs>
											</svg>
										</button>
									</div>
									<button className="demo" onClick={handleOpenModal}>
										Schedule Demo
									</button>
									{isModalOpen && (
										<div className="formModal-overlay flex" id="formModal">
											<div className="formModal-container">
												<ContactUsPage leadSource="Personalized OTT" handleCloseModal={handleCloseModal} isPersonalizedPage={true} />
											</div>
										</div>
									)}
								</div>
							</div>
						</div>
					</div>
				</section>
				{isVideoOpen && (
					<div className="video-overlay flex" id="videoModal">
						<span className="close-btn" onClick={closeVideo}>
							&times;
						</span>
						<div className="video-container">
							<video src={videoSrc} autoPlay muted loop preload="auto" style={{ width: '100%', height: 'auto' }} playsInline webkit-playsinline>
								Your browser does not support HTML5 video.
							</video>
						</div>
					</div>
				)}
				<section className="bottom-logo">
					<div className="custom-container">
						<div className="powered-img">
							<p>Powered by:</p>
							<img src={streamefyImage} alt="" />
						</div>
					</div>
				</section>
			</>
		</div>
	);
};

export default Personalized;
